import { isoToday } from '@twinden/shared';
import { appLocale } from './format';
import { t } from '../i18n';

// How a due date reads on a list item (M26, D46): "Today", "Tomorrow", "Fri",
// "24 Oct"; overdue ones say so.
export function dueLabel(
  dueDate: string,
  today: string = isoToday()
): { text: string; overdue: boolean; soon: boolean } {
  const day = (iso: string) => Date.parse(`${iso}T00:00:00Z`) / 86_400_000;
  const diff = Math.round(day(dueDate) - day(today));
  const date = new Date(`${dueDate}T00:00:00Z`);
  const named =
    diff === 0
      ? t('apps.lists.due.today')
      : diff === 1
        ? t('apps.lists.due.tomorrow')
        : diff === -1
          ? t('apps.lists.due.yesterday')
          : Math.abs(diff) < 7
            ? date.toLocaleDateString(appLocale(), {
                weekday: 'short',
                timeZone: 'UTC',
              })
            : date.toLocaleDateString(appLocale(), {
                day: 'numeric',
                month: 'short',
                timeZone: 'UTC',
              });
  return {
    text: diff < 0 ? t('apps.lists.due.overdue', { day: named }) : named,
    overdue: diff < 0,
    soon: diff >= 0 && diff <= 1,
  };
}

// Message keys; show them with t() (D146).
export const REPEAT_LABELS = {
  daily: 'apps.lists.repeat.daily',
  weekly: 'apps.lists.repeat.weekly',
  monthly: 'apps.lists.repeat.monthly',
} as const;
